import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { Grid, Button, Card, Typography, useMediaQuery, Box } from '@material-ui/core';
import clsx from 'clsx';
import _ from 'lodash';

import palette from 'theme/palette';

import { useProperties } from 'hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },

  formGroup: {
    width: '100%',
  },
  warning: {
    color: palette.warning.main,
  },
  sucess: {
    color: palette.success.main,
  },
  resendInviteMessageBox: { display: 'flex', justifyContent: 'left', height: '100%', alignItems: 'center' },
}));

const UserPropertyForm = ({ userToEdit, handleCloseModal }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const matchesSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const { userProperties, fetchUserProperties, deleteUserProperty, fetchProperties, properties, createUserProperty } =
    useProperties();

  const [selectedOption, setSelectedOption] = useState('');
  const [filteredProperties, setfilteredProperties] = useState([]);
  const [userId, setUserId] = useState(userToEdit.id);

  useEffect(() => {
    setUserId(userToEdit.id);
    fetchProperties();
    fetchUserProperties('', userToEdit.id);
  }, []);

  useEffect(() => {
    setfilteredProperties(
      _.filter(properties, (p) => {
        return p.organization_id == userToEdit.organization_id;
      })
    );
  }, [properties]);

  useEffect(() => {
    if (selectedOption === '' && filteredProperties.length > 0) {
      setSelectedOption(filteredProperties[0].id);
    }
  }, [filteredProperties]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const addUserProperty = (propid) => {
    if (propid && userId) {
      let dupe = _.filter(userProperties, (p) => {
        return p.id == propid;
      });
      if (dupe.length == 0) {
        createUserProperty({ user_id: userId, property_id: propid });
      }
    }
    fetchUserProperties('', userToEdit.id);
    handleCloseModal();
  };

  const handleDeleteButtonClick = (up) => {
    const confirmed = window.confirm(`Are you sure you want to delete ${up.name} from ${userToEdit.login}?`);
    if (confirmed) {
      deleteUP(up);
    }
  };

  const deleteUP = (up) => {
    deleteUserProperty(userToEdit.id, up.id);
    fetchUserProperties('', userToEdit.id);
    handleCloseModal();
  };

  return (
    <Card className={clsx(classes.root)}>
      <Grid container xs={12} key={Math.random() * 10000}>
        <Grid item xs={12} key={Math.random() * 10000}>
          <Box>
            <Typography key={Math.random() * 10000} component="h2" gutterBottom variant={matchesSmall ? 'h3' : 'h2'}>
              {userToEdit ? t('editing_user') + userToEdit.login : t('user_new')}
            </Typography>
          </Box>
        </Grid>
        <Grid item container xs={12} key={Math.random() * 10000}>
          <Grid item container xs={6} key={Math.random() * 10000}>
            <Typography key={Math.random() * 10000}>Add new user property:</Typography>
          </Grid>
          <Grid item container xs={6} key={Math.random() * 10000}>
            <Grid item container xs={12} key={Math.random() * 10000}>
              {filteredProperties.length > 0 && (
                <select value={selectedOption} onChange={handleChange}>
                  {filteredProperties.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              )}
            </Grid>
            <Grid item container xs={12} key={Math.random() * 10000}>
              <Button onClick={() => addUserProperty(selectedOption)}>Add</Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container xs={12} key={Math.random() * 10000}>
          <Grid item container xs={12} key={Math.random() * 10000}>
            {userProperties.map((up) => (
              <Grid
                item
                container
                xs={12}
                key={up.property_id}
                style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}
              >
                <Grid item container xs={6} key={Math.random() * 10000}>
                  <Typography key={Math.random() * 10000}>Username: {userToEdit.login}</Typography>
                </Grid>
                <Grid item container xs={6} key={Math.random() * 10000}>
                  <Typography key={Math.random() * 10000}>Property: {up.name}</Typography>
                </Grid>
                <Grid item container xs={12} key={Math.random() * 10000}>
                  <Button key={Math.random() * 10000} onClick={() => handleDeleteButtonClick(up)}>
                    Delete
                  </Button>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item container xs={12} key={Math.random() * 10000}>
          <Box key={Math.random() * 10000}>
            <Button key={Math.random() * 10000} onClick={() => handleCloseModal()} variant="outlined">
              {t('done')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

UserPropertyForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  instancePermissions: PropTypes.object,
  instanceRoles: PropTypes.object,
  userToEdit: PropTypes.object,
  organizations: PropTypes.array,
  selectedOrganization: PropTypes.object,
  currentUserRoles: PropTypes.array,
};

UserPropertyForm.defaultProps = {
  instancePermissions: undefined,
  instanceRoles: undefined,
  userToEdit: undefined,
  organizations: [],
  selectedOrganization: undefined,
  currentUserRoles: [],
};

export default UserPropertyForm;
